import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent {
    window:any=<any>window;

    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };

    getFormattedTime = (new_date:any = new Date()) => {
        let hours = `${new_date.getHours()}`.padStart(2, "0"),
            minutes = `${new_date.getMinutes()}`.padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        setTimeout(() => {
        this.cd.detectChanges();
        }, 50);
    };

    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
    }

    ngOnViewInit() {
        this.window?.emitter?.element?.addEventListener("change", this.updateView.bind(this));
    }

    ngOnDestroy() {
        this.window?.emitter?.element?.removeEventListener("change", this.updateView.bind(this));
    }

    get = (filter:any = false) => this.window?.emitter?.getEvents()?.filter(ev => {
        if(!filter) return true;
        if(filter == 'sent') return ev.configuration?.boocal?.owner == this.window.usher.getPublicToken();
        if(filter == 'received') return ev.configuration?.boocal?.resource_owner == this.window.usher.getPublicToken();
        if(filter == 'current_events') return this.getCurrent().isBetween(ev.start_timestamp, ev.end_timestamp, 'day', '[]');
        return false;
    }) || [];

    getTarget = (ev:any) => {
        if(ev.configuration?.boocal?.owner == this.window.usher.getPublicToken()) {
        let target = this.window.usher?.getChildren()?.find(user => user.public_token == ev.configuration?.boocal?.resource_owner);
        return `Evento inviato a ${target?.public_configuration?.nome || ''} (${target?.username || ''})`;
        }
        if(ev.configuration?.boocal?.resource_owner == this.window.usher.getPublicToken()) {
        let target = this.window.usher?.getChildren()?.find(user => user.public_token == ev.configuration?.boocal?.owner);
        return `Evento ricevuto da ${target?.public_configuration?.nome || ''} (${target?.username || ''})`;
        }
        return '';
    };

    getCurrent = () => {
        if(this.queryparams()['calendar']) return this.window.moment(+this.queryparams()['calendar']);
        return this.window.moment().set({hour:12,minute:0,second:0,millisecond:0});
    };

    getMonth = () => this.window.moment(this.getCurrent()).format('MMMM YYYY');
    
    prevMonth = () => {
        let current = this.getCurrent().add(-1, 'month');
        return this.router.navigate([`/calendar`], { queryParams: this.changeQueryParam({ "calendar" : current.valueOf() }) });
    };

    nextMonth = () => {
        let current = this.getCurrent().add(1, 'month');
        return this.router.navigate([`/calendar`], { queryParams: this.changeQueryParam({ "calendar" : current.valueOf() }) });
    };

    weekOfMonth = (data) => [1,2,3,4,5][0 | this.window.moment(data).date() / 7];
    weekOfYear = (data) => this.window.moment(data).weeks();

    getDayEvents = (day = 1) => this.get()
        .filter(ev => this.window.moment(day).isBetween(ev.start_timestamp, ev.end_timestamp, 'day', '[]'));

    getCurrentMonth = () => {
        let current = this.getCurrent(),
        startOfMonth = this.window.moment(current).startOf('month'),
        endOfMonth = this.window.moment(current).endOf('month'),
        day = startOfMonth,
        startDay = this.window.moment(current).startOf('month').day(),
        days = [],
        index = this.window.moment(current).startOf('month').day()-1,
        endDay = 7 - this.window.moment(current).endOf('month').day();
        
        days[0] = [];

        if(startDay < 1) startDay = 7;
        if(index<0) index = 6;

        while(startDay > 1) {
            days[0].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            startDay -= 1;
        };

        while (day <= endOfMonth) {
            let weekIndex = Math.floor(index/7);
            days[weekIndex] = days[weekIndex] || [];
            days[weekIndex].push({
                day : day,
                number : day.format('DD'),
                selected : this.window.moment(current).isSame(day, 'day'),
                free : !this.getDayEvents(day).length
            });
            day = day.clone().add(1, 'd');
            index += 1;
        };

        while(days[days.length-1].length < 7){
            days[days.length-1].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            endDay -= 1;
        };

        return days;
    };

    setCurrentDay = (day:any = {}) => {
        let current = this.window.moment(day);
        return this.router.navigate([`/calendar`], { queryParams: this.changeQueryParam({ "calendar" : current.valueOf() }) });
    };

    isCurrent = (day) => this.window.moment(day).isSame(this.window.moment(), 'day');

    getCellClass = (day) => {
        let classList = [];
        if(this.isCurrent(day.day)) classList.push('current-day');
        if(day.selected) classList.push('selected-day');
        if(!day.free && !!day.number) classList.push('event');
        if(!day.number) classList.push('prev-month');
        return classList.join(" ");
    };
}